const CONTRACT_TYPE_APPLICATION_PDF = {
  type: 'application/pdf',
};

export { CONTRACT_TYPE_APPLICATION_PDF };
